export const GOOGLE_PLAY = "https://play.google.com/store/apps/details?id=com.ecomarket_ooo"
export const APPLE_STORE = "itms-apps://itunes.apple.com/app/apple-store/id1486148531"
export const WEBSITE_DOMAIN = "https://halalfoods.ru/"